import {
  useMostAccessedCatalogsSource,
  UseMostAccessedCatalogsSourceParams,
} from './most-accessed-catalogs-source';

export const useMostAccessedCatalogsByCategorySource = (
  params: UseMostAccessedCatalogsSourceParams,
  options?: { enabled?: boolean }
) => useMostAccessedCatalogsSource('category', params, options);
